import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { APP_URL } from "../request/api";
import { request } from "../request/request";

const initialState = {
    columns: {},
    data: [],
    meta: {},
    links: {},
    loadingStatus: 'idle',
    error: null
}

export const fetchDepartures = createAsyncThunk(
    'departures/fetchDepartures',
    async ({token, page, params}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }

            const response = await request(
                `https://api.resqcore.kz/api/v2/reports?${page}&${params}`,
                'GET',
                null,
                customHeaders
            );

            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

const reportSlice = createSlice({
    name: 'departures',
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDepartures.pending, (state) => {
                state.loadingStatus = 'loading';
                state.error = null;
            })
            .addCase(fetchDepartures.fulfilled, (state, action) => {
                state.columns = action.payload.columns;
                state.data = action.payload.data;
                state.meta = action.payload.meta;
                state.links = action.payload.links;
                state.loadingStatus = 'idle';
                state.error = null;
            })
            .addCase(fetchDepartures.rejected, (state, action) => {
                state.loadingStatus = 'error';
                state.error = action.payload;
            })
    }
});

export default reportSlice.reducer;